export const GET_EXPORT_TRANSACTIONS_REQUEST = 'GET_EXPORT_TRANSACTIONS_REQUEST';
export const GET_EXPORT_TRANSACTIONS_SUCCESS = 'GET_EXPORT_TRANSACTIONS_SUCCESS';
export const GET_EXPORT_TRANSACTIONS_FAILURE = 'GET_EXPORT_TRANSACTIONS_FAILURE';
export const EXPORT_DATA_REQUEST = 'EXPORT_DATA_REQUEST';
export const EXPORT_DATA_SUCCESS = 'EXPORT_DATA_SUCCESS';
export const EXPORT_DATA_FAILURE = 'EXPORT_DATA_FAILURE';
export const SET_LAST_SPACES_INFO_FETCH_TIMESTAMP = 'SET_LAST_SPACES_INFO_FETCH_TIMESTAMP';
export const SET_IS_FETCHING_SPACES_INFO = 'SET_IS_FETCHING_SPACES_INFO';
